import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const TermsofService = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#f4f6f8",
        minHeight: "100vh",
        padding: "40px 0",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {/* Back Button */}
        <button
          className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
          onClick={() => navigate("/")}
        >
          <FaArrowLeft /> Back
        </button>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <span
            style={{
              background: "#e6f4f1",
              color: "#097969",
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            COMPLIANCE DOCUMENT
          </span>

          <h1 style={{ color: "#097969", marginTop: "10px" }}>
            Terms of Service
          </h1>

          <p style={{ color: "#666" }}>
            Effective Date: March 15, 2024
          </p>
        </div>

        <hr />

        {/* Intro */}
        <p style={{ marginTop: "20px", color: "#444" }}>
          At <b>Shreenath NX</b>, we provide school uniforms and ensure a smooth
          shopping experience. By using our website, you agree to the following terms.
        </p>

        {/* Sections */}
        {sections.map((sec, i) => (
          <div key={i} style={{ marginTop: "20px" }}>
            <h3 style={{ color: "#097969" }}>
              {i + 1}. {sec.title}
            </h3>
            <p style={{ color: "#555" }}>{sec.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Data
const sections = [
  {
    title: "Acceptance of Terms",
    text: "By using our website, you agree to these terms and conditions.",
  },
  {
    title: "Products & Services",
    text: "We offer school uniforms and related items. Details may change.",
  },
  {
    title: "Orders & Payments",
    text: "Orders are confirmed only after successful payment.",
  },
  {
    title: "Shipping & Delivery",
    text: "Delivery timelines are estimated and may vary.",
  },
  {
    title: "Returns & Refunds",
    text: "Returns are accepted only for unused products.",
  },
  {
    title: "User Responsibility",
    text: "Users must provide correct details and not misuse the website.",
  },
  {
    title: "Liability",
    text: "We are not responsible for indirect damages.",
  },
  {
    title: "Governing Law",
    text: "These terms are governed by the laws of India.",
  },
];

export default TermsofService;